import { render, staticRenderFns } from "./DialogContentMissingBankDetails.vue?vue&type=template&id=8af93000&scoped=true&"
import script from "./DialogContentMissingBankDetails.vue?vue&type=script&lang=js&"
export * from "./DialogContentMissingBankDetails.vue?vue&type=script&lang=js&"
import style0 from "./DialogContentMissingBankDetails.vue?vue&type=style&index=0&id=8af93000&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8af93000",
  null
  
)

export default component.exports